import React from 'react';
import {
  Container, Box, useTheme, useMediaQuery,
} from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

const FaqsDetailsSectionSkeleton = () => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const getnumber = () => {
    let n;
    if (isTablet && !isMobile) {
      n = 3;
    } else if (isTablet && isMobile) {
      n = 2;
    } else {
      n = 6;
    }
    return n;
  };
  return (
    <Container maxWidth="xl">
      <Skeleton
        variant="text"
        width="60%"
        height={80}
        sx={{ marginBottom: '24px' }}
      />
      {Array.from({ length: getnumber() }).map((_, item) => (
        <Skeleton
          variant="text"
          width="150px"
          height={30}
          sx={{ display: 'inline-block', marginRight: '8px' }}
          key={item}
        />
      ))}
     {Array.from({ length: 15 }).map((_, item) => (
          <Skeleton key={item}  variant="text" width="100%" height={100} />
      ))}
    </Container>
  );
};
export { FaqsDetailsSectionSkeleton };
